import { Button } from 'primereact/button'
import { keyframes, styled } from 'styled-components'

export const ActionButton = styled(Button)`
    background-color: #ba9d31;
    border: none;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    padding: 10px 15px;
    border-radius: 6px;

    .pi {
        margin-right: 10px;
        font-weight: 600;
    }

    &:hover {
        background-color: #685612;
        color: #fff;
        border-color: #ba9d31;
    }

    @media (max-width: 768px) {
        font-size: 0.9rem;
        padding: 6px;
        width: 100%;
        box-sizing: border-box;
    }
`

export const ActionButtonInverted = styled(Button)`
    width: unset;
    color: #685612;
    background-color: #fff;
    border: 2px solid #ba9d31;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 600;

    &:hover {
        background-color: #685612;
        border-color: #685612;
        color: #fff;
    }

    @media (max-width: 768px) {
        font-size: 0.9rem;
        padding: 6px;
        width: 100%;
        box-sizing: border-box;
    }
`

export const ActionButtonWhite = styled(Button)`
    background-color: #fff;
    border: 1px solid #ba9d31;
    color: #ba9d31;
    font-size: 1rem;
    font-weight: 600;
    padding: 10px 15px;
    border-radius: 6px;

    .pi {
        margin-right: 10px;
        font-weight: 600;
    }

    &:hover {
        background-color: #685612;
        color: #fff;
        border-color: #ba9d31;
    }
`

export const TransparentButton = styled(Button)`
    background-color: transparent;
    border: none;
    color: #000;
    font-size: 1rem;
    font-weight: 600;
    padding: 10px 15px;
    border-radius: 6px;

    .pi {
        font-weight: 600;
    }

    &:hover {
        background-color: #685612;
        color: #fff;
        border-color: #ba9d31;
    }
`

export const TransparentButtonLarge = styled(Button)`
    background-color: transparent;
    border: none;
    color: #000;
    font-size: 1rem;
    font-weight: 700;
    padding: 10px 15px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .pi {
        font-weight: 600;
        font-size: 2rem;
        margin-top: 0.25rem;
    }

    &:focus,
    &:hover:enabled {
        border: 1px solid #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
        opacity: 0.9;
    }

    @media (max-width: 768px) {
        padding: 6px 10px;
        font-size: 0.5rem;
    }
`

export const BasicButton = styled(Button)`
    width: unset;
    background-color: #ba9d31;
    border-color: #ba9d31;
    border-radius: 6px;

    &:hover {
        background-color: #8b761b;
    }
`

export const BasicButtonInverted = styled(Button)`
    width: unset;
    color: #685612;
    background-color: #fff;
    border: 2px solid #685612;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 600;

    &:hover {
        background-color: #ba9d31;
        color: #fff;
        border-color: #ba9d31;
    }
`

export const SelectButton = styled(Button)<{ alternate?: boolean }>`
    width: 48px;
    height: 48px;
    background-color: ${({ alternate }) => (alternate ? '#fff' : '#ba9d31')};
    border: 2px solid #ba9d31;
    border-radius: 6px;
    color: ${({ alternate }) => (alternate ? '#ba9d31' : '#fff')};
    flex-shrink: 0;

    &:hover {
        background-color: ${({ alternate }) => (alternate ? '#ba9d31' : '#8b761b')};
        color: #fff;
    }

    &:focus,
    &:hover:enabled {
        border-color: #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
    }
`

export const SelectButtonDark = styled(SelectButton)<{ selected?: boolean }>`
    width: 48px;
    height: 48px;
    background-color: ${({ selected }) => (selected ? '#66530a' : '#ba9d31')};
    border: 2px solid ${({ selected }) => (selected ? '#66530a' : '#ba9d31')};
    border-radius: 6px;
    color: '#fff';
    flex-shrink: 0;

    &:hover {
        background-color: ${({ selected }) => (selected ? '#8b761b' : '#ba9d31')};
        color: #fff;
    }

    &:focus,
    &:hover:enabled {
        border-color: #ba9d31;
        box-shadow: 0 0 3px #ba9d31;
    }
`

export const ConfirmButton = styled(Button)`
    width: max-content;
    background-color: #ba9d31;
    border-color: #ba9d31;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
        background-color: #8b761b;
    }
`

export const ConfirmButtonLarge = styled(Button)`
    width: max-content;
    background-color: #ba9d31;
    border-color: #ba9d31;
    border-radius: 6px;
    font-weight: 500;
    font-size: 20px;
    padding: 1rem;

    &:hover {
        background-color: #8b761b;
    }
`

export const ConfirmButtonInverted = styled(Button)`
    width: max-content;
    background-color: #fff;
    border-color: #ba9d31;
    color: #ba9d31;
    border-radius: 6px;
    font-weight: 600;
    margin-left: 1rem;

    &:hover {
        background-color: #8b761b;
        color: #fff;
    }
`

export const ConfirmButtonLogout = styled(Button)`
    width: max-content;
    background-color: #ba9d31;
    border-color: #ba9d31;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
        background-color: #8b761b;
    }

    @media (max-width: 600px) {
        width: 100%;
    }
`

export const CancelButton = styled(Button)`
    width: max-content;

    color: #cc3333;
    background-color: #fff;
    border-color: #cc3333;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
        color: #fff;
        background-color: #cc3333;
        border-color: #fff;
    }

    @media (max-width: 600px) {
        width: 100%;
    }
`

export const BackButton = styled(Button)`
    width: unset;
    height: 48px;
    color: #000;
    background-color: #edf2f7;
    border-color: #edf2f7;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
        color: #fff;
        background-color: #333;
        border-color: #333;
    }

    @media (max-width: 768px) {
        margin-bottom: 1rem;
    }
`

export const ForwardButton = styled(Button)`
    width: unset;
    height: 48px;
    color: #fff;
    background-color: #ba9d31;
    border-color: #ba9d31;
    border-radius: 6px;
    font-weight: 600;

    &:hover {
        color: #fff;
        background-color: #333;
        border-color: #333;
    }
`

export const EditButton = styled(Button)`
    background-color: #fff;
    width: fit-content;
    height: 48px;
    border: 3px solid #ba9d31;
    color: #685612;
    font-size: 1rem;
    font-weight: 600;
    padding: 0px 24px;
    border-radius: 6px;

    &:focus,
    &:hover:enabled {
        color: #fff;
        background-color: #8b761b;
        border-color: #8b761b;
        box-shadow: 0 0 3px #ba9d31;
    }
`

export const BasicButtonFormField = styled(BasicButton)`
    height: 2rem;
    margin-bottom: 10px;
`

export const CancelButtonFormField = styled(CancelButton)`
    height: 2rem;
    align-self: center;
    margin-bottom: 10px;
`

export const RowButton = styled(Button)<{ isSelected: boolean }>`
    width: max-content;
    min-width: 12rem;
    height: 25px;
    margin-right: 16px;
    background-color: ${({ isSelected }) => (isSelected ? '#ba9d31' : '#fff')};
    color: ${({ isSelected }) => (isSelected ? '#fff' : '#ba9d31')};
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    border: 1px solid #ba9d31;

    &:hover {
        background-color: ${({ isSelected }) => (isSelected ? '#8b761b' : '#ba9d31')};
        color: #fff;
    }

    &:focus {
        box-shadow: 0 0 3px #ba9d31;
    }
`

export const LandingButton = styled(Button)`
    font-size: 18px;
    font-weight: 600;
    background-color: #ba9d31;
    border: none;
    width: min-content;
    height: 40px;
    border-radius: 6px;
    color: #fff;
    margin: auto;

    &:focus,
    &:hover:enabled {
        background-color: #8b761b;
        border-color: none;
        box-shadow: none;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        height: 36px;
        width: 40%;
        margin-top: 1rem;
        margin-bottom: 0;
    }
`

const shimmer = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 400% 50%;
  }
`

export const FunButton = styled(LandingButton)`
    background: linear-gradient(270deg, #ba9d31, #d4b94e, #ba9d31, #d4b94e, #ba9d31);
    background-size: 800% 800%;
    animation: ${shimmer} 15s linear infinite;
    color: #fff;
    border: 1px solid #ba9d31;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const FooterButton = styled(Button)`
    font-size: 18px;
    font-weight: 600;
    background-color: #fff;
    border: none;
    width: min-content;
    height: 40px;
    border-radius: 6px;
    color: #685612;

    &:focus,
    &:hover:enabled {
        background-color: #8b761b;
        color: #fff;
        border-color: none;
        box-shadow: none;
    }
`

export const PurchaseButton = styled(Button)`
    font-size: 20px;
    font-weight: 800;
    background: transparent;
    border: none;
    width: min-content;
    color: #685612;
    text-transform: uppercase;
    margin: auto;
    margin-right: 0;

    &:focus,
    &:hover:enabled {
        color: #ba9d31;
        background-color: transparent;
        border-color: none;
        box-shadow: none;
    }

    &:focus {
        color: #685612;
    }

    @media (max-width: 768px) {
        background-color: #ba9d31;
        color: #fff;
        border-radius: 6px;
        text-transform: capitalize;
        font-weight: 600;
        margin-bottom: 1rem;
    }
`

export const PurchaseButtonAlternate = styled(Button)`
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    border: none;
    width: min-content;
    color: #000;
    background-color: #fff;
    margin: auto;
    margin-right: 0;

    &:focus,
    &:hover:enabled {
        color: #fff;
        background-color: #333;
        border-color: none;
        box-shadow: none;
    }
`

export const SoldOutText = styled.div`
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    margin: auto;
`
